import { render, staticRenderFns } from "./itemPrintparcelinformation.vue?vue&type=template&id=38388ffa&scoped=true&"
import script from "./itemPrintparcelinformation.vue?vue&type=script&lang=js&"
export * from "./itemPrintparcelinformation.vue?vue&type=script&lang=js&"
import style0 from "./itemPrintparcelinformation.vue?vue&type=style&index=0&id=38388ffa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38388ffa",
  null
  
)

export default component.exports